import React, { useState } from 'react';
import MagicCodeEntry from '../MagicCodeEntry';

/* Guest → account capture. Self-contained: owns its form state and the
   magic-link request. Rendered in the main column on mobile and in the
   rail on desktop — never both at once. */
export default function SaveStreak({ streak, title, sub }) {
  const [email, setEmail] = useState('');
  const [sleeper, setSleeper] = useState('');
  const [phase, setPhase] = useState('idle');

  const submit = async (evt) => {
    evt.preventDefault();
    if (!email.trim()) return;
    setPhase('sending');
    try {
      const res = await fetch('/api/auth/request-magic-link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim(),
          returnUrl: '/curve',
          sleeperUsername: sleeper.trim() || undefined,
        }),
      });
      setPhase(res.ok ? 'sent' : 'error');
    } catch {
      setPhase('error');
    }
  };

  return (
    <div className="cv-save">
      <div className="cv-save-t">{title || <>Save your streak{streak ? ` — it's at 🔥${streak}` : ''}.</>}</div>
      <div className="cv-save-s">{sub || "You're playing as a guest. Sign in with your Sleeper username and email to save your picks and streak to your account."}</div>
      {phase === 'sent' ? (
        <>
          <div className="cv-save-sent">Link sent. It brings you right back here.</div>
          <MagicCodeEntry email={email.trim()} redirectTo="/curve" />
        </>
      ) : (
        <form className="cv-save-form" onSubmit={submit}>
          <input className="cv-in" placeholder="Sleeper username" autoCapitalize="none" autoCorrect="off" spellCheck={false} value={sleeper} onChange={(e) => setSleeper(e.target.value)} disabled={phase === 'sending'} />
          <input className="cv-in" type="email" name="email" autoComplete="email" inputMode="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} disabled={phase === 'sending'} />
          <button className="cv-save-btn" type="submit" disabled={phase === 'sending' || !email.trim()}>
            {phase === 'sending' ? 'Sending…' : 'Send my link'}
          </button>
        </form>
      )}
      {phase === 'error' ? <div className="cv-save-err">Something went wrong. Try again.</div> : null}
    </div>
  );
}
